import { useAiAgentAvailability } from 'app/components/ai-agent-availability/useAiAgentAvailability'
import { AiAgentAvailabilityComponent } from 'app/components/ai-agent-availability/AiAgentAvailabilityComponent'

export default function Availability() {
  const hookData = useAiAgentAvailability()
  return <AiAgentAvailabilityComponent {...hookData} />
}
